module.exports = __webpack_public_path__ + "img/img_dev_pattern.efdfc4f8.png";